import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../../config/constants';

function TopicList(props) {
    const [topics, setTopics] = useState([]);
    async function getAlertTopics() {
        const response = await axios.get(`${API_URL}/monitoring-manage/getAlertTopics`);
        const { success } = response.data;
        if (success) {
            const { alertTopics } = response.data;
            setTopics(alertTopics)
        } else {
            console.log('api request failed')
        }
    }
    function getInit() {
        getAlertTopics()
    }

    const handleToggle = async (e, idx) => {
        e.preventDefault();
        const copiedArr = [...topics]
        const response= await axios.post(`${API_URL}/monitoring-manage/changeMailingActive`, { idNo: copiedArr[idx]["idNo"], value: !copiedArr[idx]["isMailingActive"] })
        const {success} = response.data
        if (success) { 
            copiedArr[idx] = { ...copiedArr[idx], isMailingActive: !copiedArr[idx]["isMailingActive"] }
            setTopics([...copiedArr]);
        } else {
            console.log('error occured')
        }
    }

    useEffect(() => {
        getInit()
    }, [])
    return (
        <div className='topicList'>
             <h3>토픽 별 메일링 설정</h3>
            <table>
                <thead>
                    <tr>
                        <th className='topic'>토픽</th>
                        <th className="description">설명</th>
                        <th className='isMailingActive'>메일링</th>
                    </tr>
                </thead>
                <tbody>
                    {topics.map((el, idx) => {
                        console.log(el)
                        const isOn = el.isMailingActive
                        return (<tr key={`topic_${idx}`}>
                            <td>{el.topic}</td>
                            <td>{el.description}</td>
                            <td>
                                <button
                                    onClick={e => handleToggle(e, idx)}
                                    style={{
                                        padding: "5px 10px",
                                        border: "none",
                                        borderRadius: "20px",
                                        backgroundColor: isOn ? "#4caf50" : "#ccc",
                                        color: "white",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                    }}
                                >
                                    {isOn ? "ON" : "OFF"}
                                </button>


                            </td>
                        </tr>)
                    })}

                </tbody>
            </table>
        </div>
    );
}

export default TopicList;